<template>
  <div class="loginWapper">


    <div class="login-container" v-if="!isok">
      <div class="login-title">请选择千川户进行授权</div>
      
      <a-spin :spinning="spinning" tip="加载中...">
        <a-table
            :columns="columns"
            :pagination="false"
            :data-source="data"
            :rowKey="(record, index) => { return index }" 
            :rowSelection="{
              selectedRowKeys,
              onChange: onSelectChange,
            }" 
          >  
          <div slot="account" slot-scope="text">
            <span v-if="text.account_role == 'PLATFORM_ROLE_SHOP_ACCOUNT'">店铺账户</span>
            <span v-else-if="text.account_role == 'PLATFORM_ROLE_QIANCHUAN_AGENT'">代理商账户</span>
            <span v-else-if="text.account_role == 'CUSTOMER_ADMIN'">管理员授权的纵横组织</span>
            <span v-else-if="text.account_role == 'CUSTOMER_OPERATOR'">协作者授权的纵横组织</span>
            <span v-else-if="text.account_role == 'ADVERTISER'">广告账户</span>
          </div>
        </a-table>
      </a-spin>
      <div class="login-btn">
        <a-button type="primary" size="large" @click="createAdversiter()" class="btn" :disabled="disabled" :loading="loading">一键授权</a-button>
      </div> 
    </div>
    <div class="login-container" v-else>
      <div class="isok">您已授权成功！</div>
    </div>
  </div>
</template>

<script>
import { qcApi, requestHttp } from '@utils/index';

export default {
  name: 'Relogin',
  data() {
    return {
      data:[],
      columns: [
        {
          title: '千川户ID',
          dataIndex: 'advertiser_id',
          key: 'advertiser_id',
        },
        {
          title: '千川户名称',
          dataIndex: 'advertiser_name',
          key: 'advertiser_name',
        },
        {
          title: '归属UID',
          dataIndex: 'uid',
          key: 'uid',
        },
        {
          title: '公司',
          dataIndex: 'company',
          key: 'company',
        },
        {
          title: '角色',
          key: 'account',
          scopedSlots: { customRender: 'account' },
        },
        {
          title: '类目',
          dataIndex: 'first_industry_name',
          key: 'first_industry_name',
        },
      ],
      selectedRow:[],
      selectedRowKeys:[],
      disabled:true,
      spinning:true,
      arr_status:'',
      uid: '',
      access_token:'',
      expires_in:'',
      refresh_token:'',
      refresh_token_expires_in:'',
      loading:false,
      isok:false
    };
  },
  components: {},
 async mounted() {
     console.log('11111111',this.$route.query);
     const {arr_status,auth_code} = this.$route.query
     if(!this.isok){
      this.getAuthAdversiter(arr_status,auth_code)
      this.arr_status = arr_status 
     }
  }, 
  methods: {
    async createAdversiter(){
      if(this.selectedRow.length==0){
        this.$message.error('请选择需要授权的千川户')
        return
      }
      this.loading = true;
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.CREATE_QIANCHUAN_AUTH}`,
        method: 'POST',
        params: {
          list:JSON.stringify(this.selectedRow),
          arr_status:this.arr_status,
          uid:this.uid,
          access_token:this.access_token,
          expires_in:this.expires_in,
          refresh_token:this.refresh_token,
          refresh_token_expires_in:this.refresh_token_expires_in,
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if(data.isthird){
        //提示授權成功
        this.isok = true
      }else{
        location.href = data.url
      }
    },
    async getAuthAdversiter(arr_status,auth_code){
      this.loading = true
      const { code, msg = '获取用户信息失败', data } = await requestHttp({
          api: `${qcApi.GET_AUTH_ADVERSITER}`,
          method: 'POST',
          params: {
            arr_status: arr_status,
            auth_code: auth_code
          },
      });
      this.spinning = false
      this.loading = false
      if (code != 1) {
        this.$message.error(msg);
        return;
      }
      this.disabled = false
      this.data = data.list
      this.uid = data.uid
      this.access_token = data.access_token
      this.expires_in = data.expires_in
      this.refresh_token  = data.refresh_token
      this.refresh_token_expires_in = data.refresh_token_expires_in
    },
    onSelectChange(selectedRowKeys, selectedRows){
      this.selectedRow = selectedRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(
        'selectedRowKeys changed: ',
        this.selectedRow,
        this.selectedRowKeys
      );
    },
    async getAccountInfo() {
        const { code, msg = '获取用户信息失败', data } = await requestHttp({
            api: `${qcApi.GET_USER_INFO}`,
            method: 'GET',
        });
        if (code != 1) {
            this.$message.error(msg);
            this.$router.replace('login')
            return;
        }
        this.$store.commit('User/SET_USER_INFO', data);
    },
  },

  destroyed() {
  },
};
</script>
<style lang="less" scoped>
.login-title{
  text-align: left;
  margin: 20px auto;
  font-size: 18px;
  font-weight: bold;
}
.login-container{
  width: 1000px;
  margin: 0 auto; 
}
.isok{
  margin-top: 100px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.login-btn{
  margin-top: 20px;
  .btn{
    width: 100%;
  }
}
</style>
